export const getGcpSourceFolderCode = (
  organizationId: string,
  managementProjectId: string,
  folderId: string,
  eonAccountId: string,
  scanningProjectId: string,
  gcpControlPlane: string,
  enableGcsBucketNotificationManagement: boolean,
  connectMethod: 'terraform' | 'bash',
  excludeProjectPatterns?: string
) => {
  const terraformCode = `\
module "gcp_source" {
    source = "https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com/gcp-eon-setup.zip"
    account_type = "source"
    organization_id = "${organizationId}"
    folder_id = "${folderId}"
    project_id = "${managementProjectId}"
    eon_account_id = "${eonAccountId}"
    scanning_project_id = "${scanningProjectId}"
    control_plane_service_account = "${gcpControlPlane}${
      enableGcsBucketNotificationManagement
        ? `\n    enable_gcs_bucket_notification_management = true`
        : ''
    }"
}`;

  const bashCode = `\
curl -fsSL https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com/gcp-eon-setup.sh \\
  -o gcp-source-setup.sh && \\
chmod +x gcp-source-setup.sh && \\
./gcp-source-setup.sh \\
  --account-type Source \\
  --organization-id ${organizationId} \\
  --folder-id ${folderId} \\
  --project-id ${managementProjectId} \\
  --eon-account-id ${eonAccountId} \\
  --scanning-project-id ${scanningProjectId} \\
  --control-plane-service-account ${gcpControlPlane}${
    enableGcsBucketNotificationManagement
      ? ` \\
  --enable-gcs-notification-management`
      : ''
  }${
    excludeProjectPatterns
      ? ` \\
  --exclude-project-patterns "${excludeProjectPatterns}"`
      : ''
  }`;

  return connectMethod === 'terraform' ? terraformCode : bashCode;
};

export const getGcpSourceOrganizationCode = (
  organizationId: string,
  managementProjectId: string,
  eonAccountId: string,
  scanningProjectId: string,
  gcpControlPlane: string,
  enableGcsBucketNotificationManagement: boolean,
  connectMethod: 'terraform' | 'bash',
  excludeProjectPatterns?: string
) => {
  const terraformCode = `\
module "gcp_source" {
    source = "https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com/gcp-eon-setup.zip"
    account_type = "source"
    organization_id = "${organizationId}"
    project_id = "${managementProjectId}"
    eon_account_id = "${eonAccountId}"
    scanning_project_id = "${scanningProjectId}"
    control_plane_service_account = "${gcpControlPlane}${
      enableGcsBucketNotificationManagement
        ? `\n    enable_gcs_bucket_notification_management = true`
        : ''
    }"
}`;

  const bashCode = `\
curl -fsSL https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com/gcp-eon-setup.sh \\
  -o gcp-source-setup.sh && \\
chmod +x gcp-source-setup.sh && \\
./gcp-source-setup.sh \\
  --account-type Source \\
  --organization-id ${organizationId} \\
  --project-id ${managementProjectId} \\
  --eon-account-id ${eonAccountId} \\
  --scanning-project-id ${scanningProjectId} \\
  --control-plane-service-account ${gcpControlPlane}${
    enableGcsBucketNotificationManagement
      ? ` \\
  --enable-gcs-notification-management`
      : ''
  }${
    excludeProjectPatterns
      ? ` \\
  --exclude-project-patterns "${excludeProjectPatterns}"`
      : ''
  }`;

  return connectMethod === 'terraform' ? terraformCode : bashCode;
};

export const getGcpSourceCode = (
  projectId: string,
  eonAccountId: string,
  scanningProjectId: string,
  gcpControlPlane: string,
  enableGcsBucketNotificationManagement: boolean,
  connectMethod: 'terraform' | 'bash'
) => {
  const terraformCode = `\
module "gcp_source" {
    source = "https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com/gcp-eon-setup.zip"
    account_type = "source"
    project_id = "${projectId || '<project-id>'}"
    eon_account_id = "${eonAccountId}"
    scanning_project_id = "${scanningProjectId}"
    control_plane_service_account = "${gcpControlPlane}${
      enableGcsBucketNotificationManagement
        ? `\n    enable_gcs_bucket_notification_management = true`
        : ''
    }"
}`;

  const bashCode = `\
curl -fsSL https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com/gcp-eon-setup.sh \\
  -o gcp-source-setup.sh && \\
chmod +x gcp-source-setup.sh && \\
./gcp-source-setup.sh \\
  --account-type Source \\
  --project-id ${projectId || '<project-id>'} \\
  --eon-account-id ${eonAccountId} \\
  --scanning-project-id ${scanningProjectId} \\
  --control-plane-service-account ${gcpControlPlane}${
    enableGcsBucketNotificationManagement
      ? ` \\
  --enable-gcs-notification-management`
      : ''
  }`;

  return connectMethod === 'terraform' ? terraformCode : bashCode;
};

export const getGcpRestoreCode = (
  projectId: string,
  eonAccountId: string,
  gcpControlPlane: string,
  hostProjectId: string,
  connectMethod: 'terraform' | 'bash'
) => {
  const terraformCode = `\
module "gcp_restore" {
    source = "https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com/gcp-eon-setup.zip"
    account_type = "restore"
    project_id = "${projectId || '<project-id>'}"
    eon_account_id = "${eonAccountId}"
    control_plane_service_account = "${gcpControlPlane}"${
      hostProjectId ? `\n    host_project_id = "${hostProjectId}"` : ''
    }
}`;

  const bashCode = `\
curl -fsSL https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com/gcp-eon-setup.sh \\
  -o gcp-restore-setup.sh && \\
chmod +x gcp-restore-setup.sh && \\
./gcp-restore-setup.sh \\
  --account-type Restore \\
  --project-id ${projectId || '<project-id>'} \\
  --eon-account-id ${eonAccountId} \\
  --control-plane-service-account ${gcpControlPlane}${
    hostProjectId
      ? ` \\
  --host-project-id ${hostProjectId}`
      : ''
  }`;

  return connectMethod === 'terraform' ? terraformCode : bashCode;
};
